import type { Role } from '../types'
import type { SettingsSection } from '../router'
import { Avatars } from './Avatars'
import { Assets } from './Assets'
import { WorkspaceSettings } from './WorkspaceSettings'

// The sidebar names the section, so this only supplies the heading and the
// one line explaining what the section is for. Tabs here would repeat the
// navigation the sidebar already provides.

const META: Record<SettingsSection, { title: string; blurb: string }> = {
  brands: {
    title: 'Settings',
    blurb: 'Workspace defaults, brand context, API keys, members, and account access.',
  },
  avatars: {
    title: 'Avatars',
    blurb: 'The people who appear in your videos, and the looks they can be filmed in.',
  },
  assets: {
    title: 'Assets',
    blurb: 'Media and reusable writing patterns used to build your videos.',
  },
  workspace: {
    title: 'Settings',
    blurb: 'The workspace name, the API keys its generations are billed to, and who can reach it.',
  },
  keys: {
    title: 'Settings',
    blurb: 'Add the provider keys this workspace uses for generation and voice.',
  },
  templates: {
    title: 'Assets',
    blurb: 'Media and reusable writing patterns used to build your videos.',
  },
}

export function Settings({ ws, section, sub, role }: {
  ws: string
  section: SettingsSection
  sub?: 'new'
  role?: Role
}) {
  const meta = META[section] ?? META.brands
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl">{meta.title}</h1>
        <p className="mt-1 text-sm text-ink-faint">{meta.blurb}</p>
      </div>
      {section === 'brands' && (
        <WorkspaceSettings ws={ws} role={role} initialTab="brand" reviewBrand={sub === 'new'} />
      )}
      {section === 'avatars' && <Avatars ws={ws} sub={sub} role={role} />}
      {(section === 'assets' || section === 'templates') && (
        <Assets ws={ws} role={role} initialTab={section === 'templates' ? 'hook' : 'insert'} />
      )}
      {section === 'workspace' && <WorkspaceSettings ws={ws} role={role} initialTab="workspace" />}
      {section === 'keys' && <WorkspaceSettings ws={ws} role={role} initialTab="keys" />}
    </div>
  )
}
